import { clstx } from '@payaca/utilities/cvaMerge';
import { FC, PropsWithChildren } from 'react';

export const FIELDSET_CLASSNAME = 'space-y-4';

const Fieldset: FC<PropsWithChildren<{ className?: string }>> = (props) => {
  const { className, children } = props;

  return <div className={clstx(FIELDSET_CLASSNAME, className)}>{children}</div>;
};

export default Fieldset;
